angular.module('wco.directives.packagingArea', ['ui.bootstrap'])

.controller('WcoPackagingAreaController', ['$scope', '$cookies', 'numberFormatService', function($scope, $cookies, numberFormatService) {
    $scope.clickedPackingInfoButton = function(packing, $event) {
        // do some code here

        // Prevent bubbling to showItem.
        // On recent browsers, only $event.stopPropagation() is needed
        if ($event.stopPropagation) $event.stopPropagation();
        if ($event.preventDefault) $event.preventDefault();
        // $event.cancelBubble = true;
        // $event.returnValue = false;

        $scope.$emit('clickedPackingInfoButton', packing);
    };

    $scope.checkIfPackingInfoMissing = function(packing){
        if (packing.LENGTH_IN_CM == 0 && !packing.LENGTH_READ_ONLY){
            return true;
        }
        if (packing.WIDTH_IN_CM == 0 && !packing.WIDTH_READ_ONLY){
            return true;
        }
        if (packing.HEIGHT_IN_CM == 0 && !packing.HEIGHT_READ_ONLY){
            return true;
        }
        if (packing.TARA_WEIGHT == 0 ){
            return true;
        }

        return false;
    };

    $scope.checkIfPackingIsFromOtherPackingSlip = function(packing){
        return packing.PACKING_SLIP_ID != $scope.packingSlip.PACKING_SLIP_ID;
    };

    $scope.getPackingClass = function(packing){
        let packingClass = '';
        if($scope.checkIfPackingInfoMissing(packing)){
            packingClass = packingClass + 'packing-info-missing ';
        }

        if($scope.checkIfPackingIsFromOtherPackingSlip(packing)){
            packingClass = packingClass + 'packing-from-other-slip ';
        }
        return packingClass;
    };

    $scope.toggledPacking = function(packing, $event) {
        if ($event.stopPropagation) $event.stopPropagation();
        if ($event.preventDefault) $event.preventDefault();

        $scope.$emit('toggledPacking', packing);
    };

    $scope.getPackingHeader = function(packing){
        let result = '(';
        result += packing.PACKAGING_MEAN_NAME;
        result += ', ' + packing.LENGTH_IN_CM + 'x' + packing.WIDTH_IN_CM + 'x' + packing.HEIGHT_IN_CM + 'cm';
        result += ', Pos.: ' + packing.PACKAGE_ITEMS.length;
        result += ', Gew.: ' + numberFormatService.formatNumberToString(packing.GROSS_WEIGHT);
        result += ')';
        return result;
    }
}])
.directive('wcoPackagingArea', ['$timeout', function($timeout) {
    return {
        controller: 'WcoPackagingAreaController',
        controllerAs: 'PackagingAreaController',
        templateUrl: function(element, attrs) {
            return attrs.templateUrl || 'angular/directives/packagingArea.html';
        },
        replace: true,
        scope:{
            packages: '=',
            packingSlip: '='
        }
    };
}]);